import Vue from 'vue';
import { store } from '../store/index.js';
import BootstrapVue from 'bootstrap-vue'
import moment from "moment";
import Loading from 'vue-loading-overlay';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.prototype.$moment = moment;
Vue.use(BootstrapVue);
import Helpers from './Helpers.js';
import axios from 'axios';
Vue.prototype.$http = axios
Vue.prototype.$helpers = Helpers;
import Debug from "debug";
Vue.prototype.$debug = Debug("main");

Vue.component('modal-alert', {
    data: function () {
        return {
            content: "",
            title: ""
        };
    },
    watch() {
    },
    methods: {
        show(msg, title) {
            this.title = title || "Alert";
            this.content = msg;
            this.$refs['modal'].show();
        },
        hide() {
            this.$refs['modal'].hide();
        }
    },
    created() {
    },
    template: `<b-modal scrollable ok-only no-stacking ref='modal' :title=title>
                 <div v-html='content'></div>
               </b-modal>`
});


import PurchaseOptions from '../vue-components/PurchaseOptions.vue'
new Vue({
    el: '#app',
    data: {

    },
    store: store,
    components: { PurchaseOptions }
});
